import { Switch as SwitchPrimitive } from "radix-ui"
import type { ComponentProps, ReactNode } from "react"
import { cn } from "cn"

export type SwitchProps = ComponentProps<typeof SwitchPrimitive.Root> & {
  label?: ReactNode
  showLabel?: boolean
  wrapperClassName?: string
}

/**
 * Figma-Achse `state` (on/off/disabled off/disabled on) wird auf Radix-Zustand
 * (`checked`) und natives `disabled` abgebildet, nicht als eigene Prop.
 */
function Switch({
  className,
  wrapperClassName,
  disabled,
  label,
  showLabel = true,
  ...props
}: SwitchProps) {
  return (
    <label
      data-slot="switch-field"
      data-disabled={disabled || undefined}
      className={cn(
        "inline-flex items-center gap-2 py-0.5",
        disabled ? "cursor-not-allowed" : "cursor-pointer",
        wrapperClassName
      )}
    >
      <SwitchPrimitive.Root
        data-slot="switch"
        disabled={disabled}
        className={cn(
          "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full bg-neutrals-v2-400 transition-colors outline-none",
          "focus-visible:ring-2 focus-visible:ring-neutrals-v2-1000 focus-visible:ring-offset-2",
          "data-[state=checked]:bg-brand-red-200",
          "disabled:cursor-not-allowed disabled:bg-neutrals-v2-300 disabled:data-[state=checked]:bg-brand-red-100",
          className
        )}
        {...props}
      >
        <SwitchPrimitive.Thumb
          data-slot="switch-thumb"
          className="pointer-events-none block size-4 translate-x-0.5 rounded-full bg-neutrals-v2-100 transition-transform data-[state=checked]:translate-x-[18px]"
        />
      </SwitchPrimitive.Root>
      {showLabel && label && (
        <span
          data-slot="switch-label"
          className="text-sm leading-5 font-normal text-labels-primary"
        >
          {label}
        </span>
      )}
    </label>
  )
}

export { Switch }
